{
  "title": "Metadata",
  "labels": {
    "properties": "Properties",
    "tags": "Tags",
    "byline": "Byline",
    "actions": "Actions",
    "otherSources": "External sources",
    "origin": "Created from",
    "source": "Source",
    "extraInformation": "Extra information",
    "versions": "Versions",
    "version": "Version",
    "editorialInfoType": "Editorial info, type",
    "slugline": "Slug",
    "category": "Category"
  },
  "actions": {
    "addNote": "Add note",
    "convertToArticle": "Plan as article",
    "convertToTimeless": "Save as timeless",
    "removeHastFromArticle": "Remove HAST from article",
    "removeHastFromTimeless": "Remove HAST from timeless"
  },
  "convertToArticle": {
    "descriptionWithPlanning": "A new planning will be created from the original. Pick a date for the new article. The timeless remains available.",
    "descriptionNoPlanning": "Pick a date for the new article. The timeless remains available.",
    "loadingPlanning": "Looking for the original planning…",
    "targetDateLabel": "Date",
    "converting": "Saving…",
    "failed": "Could not create the new document. Try again or cancel.",
    "noPlanningHint": "No original planning was found — a new planning will be created from the timeless."
  },
  "convertToTimeless": {
    "description": "Pick a subject category for the new timeless. The article remains in place.",
    "publishedDisabled": "Published articles cannot be saved as timeless."
  },
  "removeHastPrompt": {
    "title": "Remove HAST from article",
    "description": "This removes HAST and makes it a normal article. Future versions will not be sent as HAST unless you enable it again.",
    "confirm": "Remove"
  },
  "removeHastPromptTimeless": {
    "title": "Remove HAST from timeless",
    "description": "This removes HAST and makes it a normal timeless. Future versions will not be sent as HAST unless you enable it again."
  },
  "placeholders": {
    "addByline": "Add byline",
    "addSource": "Add source"
  },
  "dropDownMenuItems": {
    "internalNote": "Internal note",
    "infoToCustomer": "Info to customer"
  },
  "misc": {
    "lastUpdated": "Last updated: {{date}}",
    "noType": "No type"
  }
}
